import { api } from 'common';

import { Hl7FormFields } from './FormFields';
import { Hl7SenderDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { type BlockConfigProps } from '../../types';

export const hl7BlockConfig: BlockConfigProps<api.FlowDefinition.Hl7Block['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'hl7',
  defaultConfig: {
    message: `MSH|^~\\&|NOTABLE|NOTABLE|RECEIVING_APP|RECEIVING_FACILITY|20250101010100||ADT^A08|MSG00001|T|2.3
PID|1||12345^^^MRN||DOE^JOHN^^^^||19800101|M|||`,
    runMode: api.FlowDefinition.RunMode.Live,
    timeout: {
      value: 1,
      units: api.FlowDefinition.DurationUnits.Minutes,
    },
    destinationDatastore: undefined as unknown as '',
  },
  configFields: {
    getLanguageFieldValues: (config) => {
      return {
        [CodeMirrorLanguageType.DoubleBraceNodeFields]: [config.message],
      };
    },
    schema: api.FlowDefinition.Hl7BlockConfigSchema,
    FormFields: Hl7FormFields,
  },
  documentationMarkdown: Hl7SenderDocumentationMarkdown,
};
